import { createSlice } from "@reduxjs/toolkit";
import { FetchStatus } from "../../shared/redux.consts";
import {
  fetchGenerateOneTimePasscode,
  fetchValidateOneTimePasscode,
} from "./one-time-passcode.thunk";
import {
  OneTimePasscodeState,
  OneTimePasscodeStore,
} from "../../types/one-time-passcode";

const initialOneTimePasscodeState: OneTimePasscodeState = {
  generateStatus: FetchStatus.IDLE,
  validateStatus: FetchStatus.IDLE,
  validateResponse: null,
};

export const oneTimePasscodeSlice = createSlice({
  name: "oneTimePasscode",
  initialState: initialOneTimePasscodeState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGenerateOneTimePasscode.pending, (state) => {
        state.generateStatus = FetchStatus.LOADING;
        state.generateError = undefined;
        state.validateStatus = FetchStatus.IDLE;
        state.validateResponse = undefined;
        state.validateError = undefined;
      })
      .addCase(fetchGenerateOneTimePasscode.fulfilled, (state) => {
        state.generateStatus = FetchStatus.SUCCESS;
      })
      .addCase(fetchGenerateOneTimePasscode.rejected, (state, action) => {
        state.generateStatus = FetchStatus.FAILED;
        if (action.error?.message !== undefined) {
          state.generateError = action.error.message;
        }
      })
      .addCase(fetchValidateOneTimePasscode.pending, (state) => {
        state.validateStatus = FetchStatus.LOADING;
        state.validateError = undefined;
        state.generateError = undefined;
      })
      .addCase(fetchValidateOneTimePasscode.fulfilled, (state, action) => {
        if (action.payload) {
          state.validateStatus = FetchStatus.SUCCESS;
          state.validateResponse = {
            accessToken: action.payload.access_token,
            expiresIn: action.payload.expires_in,
            tokenType: action.payload.token_type,
          };
        } else {
          state.validateStatus = FetchStatus.FAILED;
          state.validateError = "validate OTP post failed";
        }
      })
      .addCase(fetchValidateOneTimePasscode.rejected, (state, action) => {
        state.validateStatus = FetchStatus.FAILED;
        if (action.error?.message !== undefined) {
          state.validateError = action.error.message;
        }
      });
  },
});

export const selectOneTimePasscodeState = (store: OneTimePasscodeStore) =>
  store.oneTimePasscodeState;

export default oneTimePasscodeSlice.reducer;
